export default {
  合肥市: [117.283042, 31.86119],
  滁州市: [118.107896, 32.543514],
  阜阳市: [115.709049, 32.916536],
  安庆市: [116.451502, 30.574825],
  宣城市: [118.857477, 30.684955],
  六安市: [116.23409, 31.659225],
  宿州市: [117.213919,33.860274],
  亳州市: [116.185025,33.435253],
  池州市: [117.371465,30.282082],
  芜湖市: [118.13997,31.160935],
  蚌埠市: [117.330324,33.107951],
  马鞍山市: [118.507906, 31.689362],
  铜陵市: [117.566978, 30.888245],
  淮南市: [116.773391,32.47172],
  淮北市: [116.794664, 33.971707],
  黄山市: [118.317325, 29.709239],
};